<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4C15.64 4 18.67 6.59 19.35 10.04C21.95 10.22 24 12.36 24 15C24 17.76 21.76 20 19 20H6C2.69 20 0 17.31 0 14C0 10.91 2.34 8.36 5.35 8.04C6.6 5.64 9.11 4 12 4ZM12.35 17.65L17
          13H14V9H10V13H7L11.64 17.65C11.84 17.85 12.15 17.85 12.35 17.65Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CloudDownload'
  }
</script>
